package com.shadowings.gero.data.lessons.chapter9

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_particle_iw_1
import gero.composeapp.generated.resources.exp_content_particle_iw_2
import gero.composeapp.generated.resources.exp_content_particle_iw_3
import gero.composeapp.generated.resources.exp_content_particle_iw_3_b
import gero.composeapp.generated.resources.exp_content_particle_iw_4
import gero.composeapp.generated.resources.roast
import gero.composeapp.generated.resources.exp_content_particle_iw_5
import gero.composeapp.generated.resources.exp_content_particle_iw_6
import gero.composeapp.generated.resources.exp_content_particle_iw_7
import gero.composeapp.generated.resources.exp_content_particle_iw_8
import gero.composeapp.generated.resources.exp_content_particle_iw_9
import gero.composeapp.generated.resources.exp_content_particle_iw_10
import gero.composeapp.generated.resources.exp_content_particle_iw_11
import gero.composeapp.generated.resources.exp_content_particle_iw_12
import gero.composeapp.generated.resources.exp_content_particle_iw_13
import gero.composeapp.generated.resources.exp_content_particle_iw_14
import gero.composeapp.generated.resources.exp_content_particle_iw_15
import gero.composeapp.generated.resources.exp_content_particle_iw_16
import gero.composeapp.generated.resources.exp_content_particle_iw_17
import gero.composeapp.generated.resources.exp_content_particle_iw_18
import gero.composeapp.generated.resources.exp_content_particle_iw_19
import gero.composeapp.generated.resources.exp_content_particle_iw_20
import gero.composeapp.generated.resources.exp_content_particle_iw_21
import gero.composeapp.generated.resources.exp_content_particle_iw_22
import gero.composeapp.generated.resources.exp_content_particle_iw_23
import gero.composeapp.generated.resources.exp_content_particle_iw_24
import gero.composeapp.generated.resources.exp_content_particle_iw_25
import gero.composeapp.generated.resources.exp_title_particle_iw
import gero.composeapp.generated.resources.quiz_particle_iw_1
import gero.composeapp.generated.resources.quiz_particle_iw_2
import gero.composeapp.generated.resources.quiz_particle_iw_3
import gero.composeapp.generated.resources.quiz_particle_iw_4
import gero.composeapp.generated.resources.quiz_particle_iw_5
import gero.composeapp.generated.resources.quiz_particle_iw_6
import gero.composeapp.generated.resources.quiz_particle_iw_6_opt1
import gero.composeapp.generated.resources.quiz_particle_iw_6_opt2
import gero.composeapp.generated.resources.quiz_particle_iw_6_opt3
import gero.composeapp.generated.resources.quiz_particle_iw_6_opt4
import gero.composeapp.generated.resources.quiz_particle_iw_7
import gero.composeapp.generated.resources.quiz_particle_iw_7_opt1
import gero.composeapp.generated.resources.quiz_particle_iw_7_opt2
import gero.composeapp.generated.resources.quiz_particle_iw_7_opt3
import gero.composeapp.generated.resources.quiz_particle_iw_7_opt4
import gero.composeapp.generated.resources.quiz_particle_iw_8
import gero.composeapp.generated.resources.quiz_particle_iw_8_opt1
import gero.composeapp.generated.resources.quiz_particle_iw_8_opt2
import gero.composeapp.generated.resources.quiz_particle_iw_8_opt3
import gero.composeapp.generated.resources.quiz_particle_iw_8_opt4
import gero.composeapp.generated.resources.quiz_particle_iw_9
import gero.composeapp.generated.resources.quiz_particle_iw_9_opt1
import gero.composeapp.generated.resources.quiz_particle_iw_9_opt2
import gero.composeapp.generated.resources.quiz_particle_iw_9_opt3
import gero.composeapp.generated.resources.quiz_particle_iw_9_opt4
import gero.composeapp.generated.resources.quiz_particle_iw_10
import gero.composeapp.generated.resources.quiz_particle_iw_10_opt1
import gero.composeapp.generated.resources.quiz_particle_iw_10_opt2
import gero.composeapp.generated.resources.quiz_particle_iw_10_opt3
import gero.composeapp.generated.resources.quiz_particle_iw_10_opt4

fun getParticleIwContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_2,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_3,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_3_b,
            face = Faces.Happy,
            character = Characters.Alyn,
            image = Res.drawable.roast,
            imageSize = 0.75f,
            applyFilter = false,
            fullscreenable = true,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_4,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "M17-G43-A1-D2h2:Z1-G17-D36:N29-M36:D21-Q3w0.5-G40-X1:N9:Z2",
                        rtl = false,
                        cart = false,
                        size = 56.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_5,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_6,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "M17-G43",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_7,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_8,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_9,
            face = Faces.Surprised,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_10,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_11,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_12,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_13,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_14,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_15,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_16,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_17,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_18,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_19,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_20,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_21,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_22,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_23,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_24,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_particle_iw,
            content = Res.string.exp_content_particle_iw_25,
            face = Faces.Happy,
            character = Characters.Nilo,
        )
    )
}

fun getParticleIwQuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_particle_iw_1,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_particle_iw_2,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_particle_iw_3,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_particle_iw_4,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_particle_iw_5,
            correct = true
        ),
        SingleSelectionContent(
            text = Res.string.quiz_particle_iw_6,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_particle_iw_6_opt1, correct = true),
                Option(Res.string.quiz_particle_iw_6_opt2, correct = false),
                Option(Res.string.quiz_particle_iw_6_opt3, correct = false),
                Option(Res.string.quiz_particle_iw_6_opt4, correct = false)
            ).shuffled()
        ),
        SingleSelectionContent(
            text = Res.string.quiz_particle_iw_7,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_particle_iw_7_opt1, correct = true),
                Option(Res.string.quiz_particle_iw_7_opt2, correct = false),
                Option(Res.string.quiz_particle_iw_7_opt3, correct = false),
                Option(Res.string.quiz_particle_iw_7_opt4, correct = false)
            ).shuffled()
        ),
        SingleSelectionContent(
            text = Res.string.quiz_particle_iw_8,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_particle_iw_8_opt1, correct = true),
                Option(Res.string.quiz_particle_iw_8_opt2, correct = false),
                Option(Res.string.quiz_particle_iw_8_opt3, correct = false),
                Option(Res.string.quiz_particle_iw_8_opt4, correct = false)
            ).shuffled()
        ),
        SingleSelectionContent(
            text = Res.string.quiz_particle_iw_9,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_particle_iw_9_opt1, correct = true),
                Option(Res.string.quiz_particle_iw_9_opt2, correct = false),
                Option(Res.string.quiz_particle_iw_9_opt3, correct = false),
                Option(Res.string.quiz_particle_iw_9_opt4, correct = false)
            ).shuffled()
        ),
        SingleSelectionContent(
            text = Res.string.quiz_particle_iw_10,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_particle_iw_10_opt1, correct = true),
                Option(Res.string.quiz_particle_iw_10_opt2, correct = false),
                Option(Res.string.quiz_particle_iw_10_opt3, correct = false),
                Option(Res.string.quiz_particle_iw_10_opt4, correct = false)
            ).shuffled()
        )
    )
}
